import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { AuthContext } from "shared/context/auth-context";
import { useHttpClient } from "shared/hooks/http-hook";

const POLL_INTERVAL = 5000;

const useReportProcess = () => {
  const auth = useContext(AuthContext);
  const { sendRequest } = useHttpClient();
  const [processId, setProcessId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [filename, setFilename] = useState(null);
  const [error, setError] = useState(null);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    if (!processId) return;

    setIsProcessing(true);
    setFilename(null);
    setError(null);

    const fetchProcessState = async () => {
      if (isFetchingRef.current) return;
      isFetchingRef.current = true;

      try {
        const resp = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/process/${processId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );

        if (resp?.process?.processing === false && resp?.process?.errorCode === 0) {
          setFilename(resp.process.data?.filename || null);
          setProcessId(null);
          setIsProcessing(false);
        } else if (resp?.process?.processing === false && resp?.process?.errorCode === 1) {
          setError(resp.process.error || "Rapor oluşturulurken hata oluştu.");
          setProcessId(null);
          setIsProcessing(false);
        }
      } catch (err) {
        setError("Bağlantı hatası.");
        setProcessId(null);
        setIsProcessing(false);
      } finally {
        isFetchingRef.current = false;
      }
    };

    fetchProcessState();
    const intervalId = setInterval(fetchProcessState, POLL_INTERVAL);

    return () => clearInterval(intervalId);
  }, [processId, sendRequest, auth.token]);

  const startProcess = useCallback((id) => {
    setFilename(null);
    setError(null);
    setProcessId(id);
  }, []);

  const reset = useCallback(() => {
    setProcessId(null);
    setIsProcessing(false);
    setFilename(null);
    setError(null);
  }, []);

  return { isProcessing, filename, error, startProcess, reset };
};

export default useReportProcess;
